<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h2>Sign In</h2>
    </div>
    
    <div class="login-content">
      <!-- Show login options when not logged in -->
      <div *ngIf="!loginDisplay" class="login-options">
        <p class="login-instructions">
          Sign in with your Microsoft account to access the application.
        </p>
        
        <div class="login-buttons">
          <button (click)="login()" class="login-button primary">
            Sign in with Redirect
          </button>
          
          <button (click)="loginPopup()" class="login-button secondary">
            Sign in with Popup
          </button>
        </div>
        
        <!-- Reset option for troubleshooting -->
        <div class="auth-help">
          <a href="#" (click)="$event.preventDefault(); resetAuthState()">
            Having trouble signing in?
          </a>
        </div>
      </div>
      
      <!-- Error message display -->
      <div *ngIf="errorMessage" class="login-error">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</div>